import React, { ReactElement, FC } from "react";
import Loader from "../Loader";
import Const from "const.json";
import './WithApi.scss'
import NoData from "../NoData";
interface WithApiProps {
    data: any
    loading: boolean;
    error: string;
    children: ReactElement

}

const WithApi: FC<WithApiProps> = ({ data, loading, error, children }) => {
    if (loading) {
        return (
           <Loader/>
        )
    }

    if (error) {
        return <div className="custom-error">{`${Const.haveError} ${error}`}</div>
    }

    if ((data && data.length === 0) || !data) {
        return <NoData/>;
    }

    return children;
}

export default WithApi;